import { NGXLogger } from 'ngx-logger';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { DEFINITIONS } from '../shared/app-definitions';

import { AuthenticationService } from '../_services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  private logger = inject(NGXLogger);
  private authService = inject(AuthenticationService);

  canActivate() {
    return this.checkAuthorization();
  }

  checkAuthorization(): Observable<boolean> {
    return this.authService.isAuthenticated.pipe(
        map((isAuth: boolean) => {
          this.logger.info('(auth.guard) checkAuthorization, this.authService.isAuthenticated => ' + isAuth);
          if (!isAuth) {
            //login (and forward redirecturl to server by query param)
            const redirectUrl = window.location.origin + '/orders/administration' + window.location.search;
            window.open(DEFINITIONS.serverUrlGeneratorLogin + '?redirecturl=' + btoa(redirectUrl), '_self');
            return false;
          } else {
            return true;
          }
        })
     );
  }
}

